import React from 'react'
import { Bleed, Divider } from '@fs/zion-ui'
import PanelHeaderLayoutBand from '../../../../components/generic/panels/shared/PanelHeaderLayoutBand'

const DEFAULT_HEADING_SIZE = 'H5'

export default function PanelHeader({ heading, caption, headingSize = DEFAULT_HEADING_SIZE }) {
  return (
    <Bleed top>
      <div style={{ transform: 'scaleY(-1)' }}>
        <Divider fullWidth />
      </div>
      <PanelHeaderLayoutBand heading={heading} caption={caption} headingSize={headingSize} />
    </Bleed>
  )
}
